// Module
var code = "<div class=\"hamburger__line\"></div> <div class=\"hamburger__text\"> <div class=\"uppercase p3 font-body text-reveal text-reveal--visible\" data-reveal-classes=\"font-heading\"> menu </div> </div> ";
// Exports
export default code;